import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrollt bei jedem Routenwechsel an den Seitenanfang.
 * Wird einmal global im AppShell gerendert.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 'auto' damit Senior:innen keinen langsamen Scroll-Animationseffekt sehen
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
